<template>
    <aside
        :class="{
            'at1024:w-[303px] shrink-0 flex-none': !settings.is_sourcing_mode,
            'w-full': settings.is_sourcing_mode,
        }"
    >
        <SeclockMultiselect
            class="mb-6"
            :options="manufacturers?.filter((manufacturer) => manufacturer.logo)?.map((manufacturer) => ({'label': manufacturer.name,'value': manufacturer.slug}))"
            :placeholder="$t('Choose a manufacturer')"
            :searchable="true"
            :can-clear="false"
            :large="false"
            @change="navigateToShow($event)"
        />
        <div
            class="w-full mb-8 p-6 rounded"
            :class="{
                'bg-white type-secondary at1024:mx-auto at1024:px-0 mr-auto' : !settings.is_sourcing_mode,
                'bg-gray-150': settings.is_sourcing_mode,
            }"
        >
            <img
                :class="{
                    'w-80 h-auto at1024:mx-auto at1024:px-0 mr-auto' : !settings.is_sourcing_mode,
                }"
                :src="useAssetTransforms().marketingAssetUrl(manufacturer.logo)"
                :alt="manufacturer.logo.name ?? manufacturer.name"
            />
        </div>
        <div
            v-if="manufacturer.channels?.find(channel => channel?.pivot.type === 1)?.channel"
            class="flex items-center gap-2"
            dusk="manufacturer-phone-channel"
        >
            <BaseSvg name="icon-local-phone" class="w-4 h-4 shrink-0" aria-hidden="true" />
            <a :href="'tel:' + manufacturer.channels?.find(channel => channel?.pivot.type === 1)?.channel">{{ manufacturer.channels.find(channel => channel?.pivot.type === 1)?.channel }}</a>
        </div>
        <div
            v-if="manufacturer.channels?.find(channel => channel?.pivot.type === 4)?.channel"
            class="flex items-center gap-2"
            dusk="manufacturer-website-channel"
        >
            <BaseSvg name="icon-earth-globe" class="w-4 h-4 shrink-0" aria-hidden="true" />
            <a
                target="_blank"
                :href="manufacturer.channels?.find(channel => channel?.pivot.type === 4)?.channel"
                class="hover:decoration-solid break-all underline underline-offset-4 decoration-dotted overflow-hidden whitespace-nowrap truncate"
            >
                <span aria-hidden="true">{{ manufacturer.channels?.find(channel => channel?.pivot.type === 4)?.channel }}</span>
                <span class="sr-only">Visit the {{ manufacturer?.name }} website</span>
            </a>
        </div>
        <div class="border-b border-keyline-primary my-6"></div>
        <div v-if="vendorCategories.length > 0">
            <h3 class="text-left type-secondary mb-2">Product categories</h3>
            <ul class="flex flex-col w-full mb-2">
                <li v-for="vendorCategory in vendorCategories">
                    <a
                        :href="route('web.catalog.manufacturers.show',{
                                vendor_reference: manufacturer.slug,
                                filters: {
                                0:{
                                        field: 'filter_category',
                                        values: [vendorCategory],
                                        type: 'any',
                                    },
                                },
                            })"
                        class=" rounded whitespace-nowrap truncate text-left w-full font-medium block py-2.5 px-3 hover:type-primary hover:bg-gray-tier-5 active:bg-gray-tier-6 type-secondary bg-inherit"
                    >
                        {{ vendorCategory }}
                    </a>
                </li>
            </ul>
        </div>
        <a
            :href="
                route('web.catalog.products.index', {
                    filters: {
                        1: {
                            field: 'filter_manufacturer',
                            values: [manufacturer.name],
                            type: 'any',
                        },
                    },
                })
            "
            class="text-sm w-fit flex items-center gap-1 type-secondary underline underline-offset-4 decoration-dotted hover:decoration-solid hover:type-primary"
        >
            {{ $t("View all products") }} <BaseSvg name="icon-arrow-right-alt" class="w-5 h-5 shrink-0" aria-hidden="true" />
        </a>
    </aside>
</template>

<script setup>
import {useAssetTransforms, useUser} from "@/Composables";
import {BaseSvg, SeclockMultiselect} from "@/Components";
import {inject} from "vue";
import { router } from "@inertiajs/vue3";
const route = inject('route');

const { settings } = useUser();
const props = defineProps(['manufacturer', 'vendorCategories', 'manufacturers']);

const navigateToShow = (slug) => {
    router.visit(route('web.catalog.price-books.show', slug))
};
</script>
